module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mw7-ns center-ns"
  }, [_c('div', {
    staticClass: "mt4 mb4 pt4"
  }, [_c('div', {
    staticClass: "f5 db mb3 fw6"
  }, [_vm._v("Selected Plan")]), _vm._v(" "), (_vm.contactInfo.length > 1) ? _c('div', {
    staticClass: "mb3"
  }, [_c('label', {
    staticClass: "f6 fw5 di mb2 lh-copy"
  }, [_vm._v("\n        Please enter the cell phone number that will be associated with each plan below.\n        Each person will receive a text message with their own login credentials after you checkout.\n        Each person must login from their own phone and complete verification on their own device.\n      ")])]) : _vm._e(), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.contactInfo), function(contact, index) {
    return _c('tr', {
      key: ("coverage-" + index)
    }, [_c('td', [_vm._v("\n            " + _vm._s(_vm.selectedCoverages[index].make && _vm.selectedCoverages[index].model ?
      (_vm.selectedCoverages[index].make + ' ' + _vm.selectedCoverages[index].model + ' - ') : '') + "\n            " + _vm._s(_vm.selectedCoverages[index].name) + "\n          ")]), _vm._v(" "), _c('td', [_c('InputMask', {
      directives: [{
        name: "focus",
        rawName: "v-focus",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
      attrs: {
        "id": ("phone-" + index),
        "type": "tel",
        "name": ("phone-" + index),
        "mask": "+1 (999) 999-9999",
        "placeholder": "+1"
      },
      on: {
        "input": function($event) {
          return _vm.setPhone(index)
        }
      },
      model: {
        value: (contact.phone),
        callback: function($$v) {
          _vm.$set(contact, "phone", $$v)
        },
        expression: "contact.phone"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedCoverages[index].phoneError),
        expression: "selectedCoverages[index].phoneError"
      }],
      staticClass: "red f7"
    }, [_vm._v("\n              " + _vm._s(_vm.selectedCoverages[index].phoneError) + "\n            ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedCoverages[index].isInvalid),
        expression: "selectedCoverages[index].isInvalid"
      }],
      staticClass: "red f7"
    }, [_vm._v("\n              Please enter a valid phone number\n            ")])], 1), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.primary),
        expression: "contact.primary"
      }],
      staticClass: "di",
      attrs: {
        "id": ("primary-" + index),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(contact.primary) ? _vm._i(contact.primary, null) > -1 : (contact.primary)
      },
      on: {
        "change": [function($event) {
          var $$a = contact.primary,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(contact, "primary", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(contact, "primary", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(contact, "primary", $$c)
          }
        }, function($event) {
          return _vm.setPrimary(index)
        }]
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ak-payment-method', {
    ref: "paymentForm",
    attrs: {
      "isStudentPlan": this.isStudentPlan
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "promo_code"
    }
  }, [_vm._v("\n      Discount / Referral Code\n      "), (this.discountMessage.error) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" - INVALID - " + _vm._s(this.discountMessage.error))]) : (this.discountMessage.message) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" - VALID - " + _vm._s(this.discountMessage.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group-flex mb2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_code),
      expression: "discount_code"
    }],
    staticClass: "input-reset ba b--black-20 pa2 db w-100 br1 ttu",
    attrs: {
      "id": "promo_code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.discount_code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitDiscountCode.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "f6 link dim ba bw2 ph3 pv2 dib dark-green submit-btn",
    on: {
      "click": _vm.submitDiscountCode
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "mb2 f6"
  }, [_c('div', {
    staticClass: "f5 db mb3 fw6"
  }, [_vm._v("Checkout:")]), _vm._v(" "), _vm._l((_vm.selectedCoverages), function(coverage, index) {
    return _c('div', {
      key: index,
      staticClass: "black lh-copy"
    }, [_vm._v("\n      $" + _vm._s(coverage.price.toFixed(2)) + " -\n      " + _vm._s(coverage.make && coverage.model ? coverage.make + ' ' + coverage.model + ' - ' : '') + "\n      " + _vm._s(coverage.name) + "\n    ")])
  }), _vm._v(" "), (_vm.showDiscount) ? _c('div', {
    staticClass: "black lh-copy"
  }, [_vm._v("\n      Discounts:\n      "), _vm._l((_vm.discountsToDisplay), function(discount) {
    return _c('div', {
      key: discount.name,
      staticClass: "little-left-padding"
    }, [_vm._v("\n        -$" + _vm._s(discount.amount.toFixed(2)) + " - " + _vm._s(discount.name) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "black lh-copy mt3"
  }, [_vm._v("Total: $" + _vm._s(_vm.total) + " (" + _vm._s(_vm.selectedCountryCurrency.currency_code) + ")\n      "), (_vm.oneTimeVerificationCharge) ? _c('span', [_vm._v("one-time verification charge")]) : _vm._e(), _vm._v(" "), (_vm.applyTwoYearsUpfrontDiscount) ? _c('span', [_vm._v("(2 year upfront charge applied)")]) : _vm._e()]), _vm._v(" "), (_vm.featureFlagMonthlyBillingActive) ? _c('div', {
    staticClass: "mw5-ns left-ns tc mb4 pt4 lh-copy flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    staticClass: "dn",
    attrs: {
      "id": "interval1",
      "type": "radio",
      "name": "interval"
    },
    domProps: {
      "value": 'annual',
      "checked": _vm._q(_vm.interval, 'annual')
    },
    on: {
      "change": function($event) {
        _vm.interval = 'annual'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br1 br--right b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "interval1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.interval = 'annual'
      }
    }
  }, [_vm._v("Annual")]), _vm._v(" "), _c('span', {
    staticClass: "pv2 ph3 tc b silver"
  }, [_vm._v("OR")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    staticClass: "dn",
    attrs: {
      "id": "interval2",
      "type": "radio",
      "name": "interval"
    },
    domProps: {
      "value": 'monthly',
      "checked": _vm._q(_vm.interval, 'monthly')
    },
    on: {
      "change": function($event) {
        _vm.interval = 'monthly'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br1 br--left b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "interval2"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.interval = 'monthly'
      }
    }
  }, [_vm._v("Monthly")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "mv3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accept),
      expression: "accept"
    }],
    staticClass: "di",
    attrs: {
      "id": "accept",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accept) ? _vm._i(_vm.accept, null) > -1 : (_vm.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.accept = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "mv4 flex justify-center"
  }, [_c('ak-button', {
    staticClass: "flex-grow flex-grow-off-ns inter fw6",
    attrs: {
      "disabled": !_vm.formComplete || _vm.loading,
      "green": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Register\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "black f6 mv4 mw7-ns center tc lh-copy"
  }, [_vm._v("\n    Elite Risk Insurance Solutions Lic#0G40499. ")]), _vm._v(" "), (_vm.showDisclaimerModal) ? _c('ak-modal', {
    attrs: {
      "title": ""
    },
    on: {
      "close": _vm.toggleDisclaimerModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v(_vm._s(_vm.minnesotaDiscalimer))])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "65%"
    }
  }, [_vm._v("Plan Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Cell Phone Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Primary")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 fw5 di mb2 lh-copy",
    attrs: {
      "for": "accept"
    }
  }, [_vm._v("\n      I agree that I have thoroughly read, understand, and accept the\n      "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/legal",
      "target": "_blank"
    }
  }, [_vm._v("terms of service & conditions")]), _vm._v("\n      as well as the "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/coverage-info-faqs/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("AKKO website's FAQs")]), _vm._v(" about plan protections and claims.\n      I also acknowledge and agree to receive and view all plan documentation, including Terms and Conditions and Plan Confirmation (if any), electronically as well as receive automated transactional messages via email and SMS in accordance with AKKO's Privacy Policy.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f3c2bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration-v2/CheckoutWm.vue
// module id = 1245
// module chunks = 0